import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";

interface PreviewDocumentProps {
  src?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    src: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const getDocumentExtension = computed(() => {
  if (props.src) {
    const parts = props.src.split(".");
    return parts.length > 1 ? parts.pop()?.toUpperCase() : "UNKNOWN";
  }
  return "No Document";
});

function onPreviewDocument() {
  const previewElement = document.querySelector(".view-box") as HTMLElement;
  if (previewElement) {
    previewElement.click();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_c_img = _resolveComponent("c-img")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "title", {}, () => [
      _createElementVNode("div", {
        class: "document",
        onClick: onPreviewDocument
      }, " Document (" + _toDisplayString(getDocumentExtension.value) + ") ", 1)
    ]),
    _createVNode(_component_c_img, {
      src: props.src,
      style: {"display":"none"},
      class: "view-box"
    }, null, 8, ["src"])
  ]))
}
}

})